import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function useRedirectIf(path, shouldRedirect) {
  const navigate = useNavigate();

  useEffect(() => {
    if (shouldRedirect) {
      navigate(path, { replace: true });
    }
  }, [navigate, path, shouldRedirect]);
}
